import { Spinner } from '@heroui/react'

interface FullPageLoaderProps {
  label?: string
}

export function FullPageLoader({ label = 'Loading…' }: FullPageLoaderProps) {
  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center gap-3"
      role="status"
      aria-live="polite"
    >
      <Spinner size="lg" />
      <p className="text-muted text-sm">{label}</p>
    </div>
  )
}
